import * as Yup from 'yup';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';

// form
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// @mui
import { Stack } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// components
import { FormProvider, RHFTextField } from '../../../components/hook-form';

import { api as authApi, actions as authActions, constants as authConstants } from '../../../store/domains/auth';

// ----------------------------------------------------------------------

export default function LoginForm() {
  const location = useLocation();
  const dispatch = useDispatch();

  const params = new URLSearchParams(location.search);
  const phone = params.get('phone');

  const [otpMutation] = authApi.usePostOtp();

  const OtpSchema = Yup.object().shape({
    otp: Yup.string().required('OTP is required'),
  });

  const defaultValues = {
    otp: '',
  };

  const methods = useForm({
    resolver: yupResolver(OtpSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = async (data) => {
    const response = await otpMutation({ ...data, phone }).unwrap();
    if (response) {
      const userType = `${response?.data?.userInfo?.userType}_${response?.data?.userInfo?.role}`;
      localStorage.setItem('accessToken', response?.data?.accessToken);
      localStorage.setItem(authConstants.PROVIDER_ID, response?.data?.userInfo?.providerIds[0]);
      localStorage.setItem(authConstants.USER_TYPE, userType);
      dispatch(authActions.setProviderID(response?.data?.userInfo?.providerIds[0]));
      dispatch(authActions.setUserType(userType));
      if (response?.data?.userInfo?.providerIds.length > 1) {
        dispatch(authActions.setMultiUser(true));
        localStorage.setItem(authConstants.MULTI_USER, true);
        window.location.assign('/provider');
        return;
      }
      console.log(response);
      if (userType === 'DISTRIBUTOR_ADMIN') {
        window.location.assign('/dashboard/start-pack');
      } else if (userType === 'DISTRIBUTOR_ARCHIVE') {
        window.location.assign('/dashboard/dealer-archive');
      } else if (userType === 'DEALER_SERVICE') {
        window.location.assign('/dashboard/transfer-ownership');
      } else {
        window.location.assign('/dashboard/dealer');
      }
    }
  };
  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Stack spacing={3} sx={{ my: 2 }}>
        <RHFTextField autoFocus name="otp" label="otp" />
      </Stack>
      <LoadingButton fullWidth size="large" type="submit" variant="contained" loading={isSubmitting}>
        Submit
      </LoadingButton>
    </FormProvider>
  );
}
